interface IParams {
  hostKey: string;
  valueKey: string;
}

export const getTelemetryKey = ({ hostKey, valueKey }: IParams): string => {
  return `react.${hostKey}.servicePickerWidget.${valueKey}`;
};
